module.exports = __webpack_public_path__ + "img/tooltip-vallone-como-gold-01.0b27e726.jpg";